module.exports = __webpack_public_path__ + "img/coupon_used.674a22ce.png";